import PilotWechatCrawlArticlesAPI from 'dashboard/api/pilot/wechatCrawlArticles';

const types = {
  SET_UI_FLAG: 'SET_UI_FLAG',
  SET_ARTICLES: 'SET_ARTICLES',
  SET_META: 'SET_META',
};

export default {
  namespaced: true,

  state: {
    uiFlags: {
      isFetching: false,
    },
    records: [],
    meta: {
      total_count: 0,
      current_page: 1,
      total_pages: 1,
      per_page: 25,
      status_counts: {
        all: 0,
        pending: 0,
        success: 0,
        failed: 0,
        filtered: 0,
      },
    },
  },

  mutations: {
    [types.SET_UI_FLAG](state, data) {
      state.uiFlags = { ...state.uiFlags, ...data };
    },
    [types.SET_ARTICLES](state, articles) {
      state.records = articles;
    },
    [types.SET_META](state, meta) {
      state.meta = { ...state.meta, ...meta };
    },
  },

  actions: {
    async fetch(
      { commit },
      { status, search, page, knowledgeBaseId, scope } = {}
    ) {
      commit(types.SET_UI_FLAG, { isFetching: true });
      try {
        const { data } = await PilotWechatCrawlArticlesAPI.get({
          status,
          search,
          page,
          knowledgeBaseId,
          scope,
        });
        commit(types.SET_ARTICLES, data.payload);
        commit(types.SET_META, data.meta);
        commit(types.SET_UI_FLAG, { isFetching: false });
        return data;
      } catch (error) {
        commit(types.SET_UI_FLAG, { isFetching: false });
        throw error;
      }
    },

    async update({ dispatch }, { id, knowledgeBaseId }) {
      const response = await PilotWechatCrawlArticlesAPI.update(
        id,
        knowledgeBaseId
      );
      return response;
    },

    async batchDestroy({ commit }, ids) {
      commit(types.SET_UI_FLAG, { isDeleting: true });
      try {
        await PilotWechatCrawlArticlesAPI.batchDestroy(ids);
        commit(types.SET_UI_FLAG, { isDeleting: false });
      } catch (error) {
        commit(types.SET_UI_FLAG, { isDeleting: false });
        throw error;
      }
    },

    async batchUpdate({ commit }, { ids, knowledgeBaseId }) {
      commit(types.SET_UI_FLAG, { isUpdating: true });
      try {
        await PilotWechatCrawlArticlesAPI.batchUpdate(ids, knowledgeBaseId);
        commit(types.SET_UI_FLAG, { isUpdating: false });
      } catch (error) {
        commit(types.SET_UI_FLAG, { isUpdating: false });
        throw error;
      }
    },
  },

  getters: {
    getUIFlags: state => state.uiFlags,
    getArticles: state => state.records,
    getMeta: state => state.meta,
    getStatusCounts: state => state.meta.status_counts,
  },
};
